import {ajax_get, ajax_post} from "./index";

export const getALLMenu = (data) => ajax_get('/museummenu', data);
export const getInfo = (data) => ajax_get('/museumfillinfo', data);
export const getbaseInfo = (data) => ajax_get('/museuminfo', data);
export const savebaseingo = (data) => ajax_get('/museuminfosave', data);
export const otherfiles = (data)=>ajax_get('otherfilelist', data)
export const getSuggest = (data)=>ajax_get('proposallist', data)
export const saveitemdata = (data) => ajax_post('/museumitemsave', data);